'use strict';

module.exports = function parseDocumentType(source) {
  if (source !== 'FA') {
    throw new Error('document type must be FA');
  }
  return source;
};



// WEBPACK FOOTER //
// ./src/parsers/pcc/parseDocumentType.js